const BASE = '/v1/leads/paid-influencer-application'

/**
 * Client-side data access for the paid-influencer lead application.
 * Imperative `$fetch` via `useApi()` (mutations + on-demand reads) targeting
 * the BFF, which proxies the upstream `lead-application/v1/...` endpoints.
 */
export const useInfluencerApplicationRepository = () => {
  const api = useApi()

  const create = (args: CreateInfluencersApplicationArgs) =>
    api<InfluencerApplication>(BASE, { method: 'POST', body: args })

  const updateBySlug = ({
    slug,
    ...args
  }: UpdateInfluencersApplicationBySlugArgs) =>
    api<InfluencerApplication>(`${BASE}/${slug}`, { method: 'PUT', body: args })

  const findBySlug = ({ slug }: FindInfluencersApplicationBySlugArgs) =>
    api<InfluencerApplication>(`${BASE}/${slug}`, { method: 'GET' })

  return { create, updateBySlug, findBySlug }
}
